import React from 'react';
import {InstructorCard} from '../instructor-card/instructor-card.react-component';
import styles from './instructor-list.module.scss';
import {useI18n} from '@udemy-v2/i18n';
import classNames from 'classnames';
import {useInstructorDetails} from '@/lib/hooks/use-instructor-details';

/**
 * Renders a list of InstructorCard components for each instructor
 *
 * @example
 * ```jsx
 * <InstructorList instructors={course.instructors} />
 * ```
 */
export const InstructorList = () => {
    const {gettext} = useI18n();
    const instructorDetails = useInstructorDetails();
    if (!instructorDetails?.length) return null;

    return (
        <div className={classNames('ud-heading-xl', styles['instructor-list-container'])}>
            {instructorDetails.length > 1 ? gettext('Instructors') : gettext('Instructor')}
            <div className={styles['instructor-list-card']}>
                {instructorDetails.map((instructor, index) => {
                    if (!instructor.url) return null;
                    return (
                        <InstructorCard
                            key={`${instructor.url}-${instructor.id}`}
                            instructor={instructor}
                            index={index}
                        />
                    );
                })}
            </div>
        </div>
    );
};
